import { CERoleGrantAttributesBase } from './ce-role-grant-attributes-base'


export class CERoleGrantAttributes extends CERoleGrantAttributesBase {

}